import { render, staticRenderFns } from "./Blessors.vue?vue&type=template&id=76f7bf4d&scoped=true&"
import script from "./Blessors.vue?vue&type=script&lang=js&"
export * from "./Blessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f7bf4d",
  null
  
)

export default component.exports